import React from 'react';

import Button from '../../../components/ui/Button';

const MobileViewToggle = ({ activeView, onViewChange }) => {
  return (
    <div className="lg:hidden fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 bg-card border border-border rounded-full shadow-2xl p-2 flex gap-2">
      <Button
        variant={activeView === 'tree' ? 'default' : 'ghost'}
        size="sm"
        iconName="FolderTree"
        iconPosition="left"
        onClick={() => onViewChange('tree')}
        className="rounded-full"
      >
        Files
      </Button>
      <Button
        variant={activeView === 'preview' ? 'default' : 'ghost'}
        size="sm"
        iconName="FileCode2"
        iconPosition="left"
        onClick={() => onViewChange('preview')}
        className="rounded-full"
      >
        Preview
      </Button>
    </div>
  );
};

export default MobileViewToggle;